// eslint-disable-next-line
export const WORKFLOW_ID = 'DebtManagementWorkflow';
export const ANALYTICS_ID = 'debt_management_workflow';
